import React from 'react';
import Icon, { IconName } from './Icon';

export interface TabItem<T extends string = string> {
  id: T;
  label: string;
  icon: IconName;
}

interface TabBarProps<T extends string> {
  items: TabItem<T>[];
  active: T;
  onChange: (id: T) => void;
}

function TabBar<T extends string>({ items, active, onChange }: TabBarProps<T>) {
  return (
    <nav className="tab-bar" aria-label="Hauptnavigation">
      {items.map((item) => (
        <button
          key={item.id}
          className={`tab-bar-btn ${item.id === active ? 'active' : ''}`}
          onClick={() => onChange(item.id)}
          aria-current={item.id === active ? 'page' : undefined}
          aria-label={item.label}
        >
          <Icon name={item.icon} size={22} className="tab-icon" />
          <span className="tab-label">{item.label}</span>
        </button>
      ))}
    </nav>
  );
}

export default TabBar;
